{
    "FormEngineSignalWfl": {
        "title": "Signal",
        "description": "Trigger Signals from within your form to start a Workflow"
    },
    "mask": {
        "FormEngineSignalWfl": {
            "groupTitle": "Signal",
            "signalType": "Signal Type",
            "signalOnChangeSource": "Source Field",
            "options": {
                "default": "Manually Triggered",
                "onFieldChange": "On Field Change"
            }
        }
    }
}